const StatusChannelEnum = {
  8: "REGISTER_PENDING_APPROVAL",
  11: "REGISTER_REJECTED",
  12: "REGISTER_REVIEWED",
  10: "REGISTER_APPROVED",
  9: "UPDATE_PENDING_APPROVAL",
  14: "UPDATE_REJECTED",
  15: "UPDATE_REVIEWED",
  13: "UPDATE_APPROVED",
  16: "CANCEL_PENDING_APPROVAL",
  17: "CANCEL_APPROVED",
  18: "CANCEL_REJECTED",
  19: "CANCEL_REVIEWED",
};

export { StatusChannelEnum };
